


























































import { Component, Mixins, Watch } from 'vue-property-decorator';
// @ts-ignore hack
import TableMixin from '@root/common/mixins/table';
// @ts-ignore hack
import TableWidthMixin from '@root/common/mixins/table-width';
// @ts-ignore hack
import { serchSysMsg, messageIsRead, messageIsDel } from '@/api/message-center/index';
import _ from 'lodash';

@Component({
  name: 'MessageCenter'
})
export default class MessageCenter extends Mixins(TableMixin, TableWidthMixin) {
  activeKey: string = '01'; // 默认选中未读消息
  tabPaneList: any[] = [
    {
      key: '01',
      title: '未读消息'
    },
    {
      key: '00',
      title: '已读消息'
    }
  ];
  tableLoading: boolean = false; // 表格loading
  selectedRowKeys: string[] = [];
  tableData: any[] = [];

  // 表头
  get tableColums() {
    return [
      {
        title: '消息类型',
        dataIndex: 'eventType',
        width: 220,
        scopedSlots: { customRender: 'message-type' }
      },
      {
        title: '消息详情',
        dataIndex: 'msg',
        width: 900,
        scopedSlots: { customRender: 'message-detail' }
      },
      {
        title: '接收时间',
        dataIndex: 'pushTime',
        width: 220
      }
    ];
  }

  onChangeTabs(val: any) {
    this.current = 1;
    this.selectedRowKeys = [];
    this.fetchTableData();
  }

  onSelectChange(selectedRowKeys: string[], selectedRows: any) {
    this.selectedRowKeys = selectedRowKeys;
  }

  onSelectAll(selected: any, selectedRows: any, changeRows: any) {
    console.log(selected, selectedRows, changeRows);
  }

  // 已读
  async readMsg() {
    const params = _.cloneDeep(this.selectedRowKeys).join(',');
    await messageIsRead({ pkMsgId: params });
    this.selectedRowKeys = [];
    this.fetchTableData();
  }

  // 删除
  async delMsg() {
    const params = _.cloneDeep(this.selectedRowKeys).join(',');
    await messageIsDel({ pkMsgId: params });
    this.selectedRowKeys = [];
    this.fetchTableData();
  }

  // 前往处理
  goToDetail(data: { eventType: string; parkDay: any; parkId: any }) {
    if (data.eventType === '僵尸车辆监控事件') {
      this.$router.push({ name: 'CLEAN_CAR', query: { parkDay: data.parkDay, parkId: data.parkId } });
    } else if (data.eventType === '车辆月卡到期提醒') {
      this.$router.push({ name: 'LONG_RENTAL_CAR_BUSSINESS', query: { parkDay: data.parkDay, parkId: data.parkId } });
    } else if (data.eventType === '车辆产权到期提醒') {
      this.$router.push({ name: 'PROPERTY_CAR_LIST', query: { parkDay: data.parkDay, parkId: data.parkId } });
    }
  }

  total = 0;
  current = 1;
  pageSize = 10;

  // 获取列表数据
  async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const { data } = await serchSysMsg({
        status: this.activeKey,
        currPage: this.current,
        pageSize: this.pageSize
      });
      this.tableData = data.datas;
      this.total = Number(data.totalNum);
      this.current = Number(data.currPage);
      this.pageSize = Number(data.pageSize);
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  async created() {
    this.fetchTableData();
  }

  // 切换分页清空选中状态
  @Watch('pagination')
  onPaginationChange(newVal: string, oldVal?: string) {
    this.selectedRowKeys = [];
  }
}
